import React from 'react';
import { portfolioImages } from '../../data/mock';
import { useLanguage } from '../../context/LanguageContext';
import OptimizedImage from '../OptimizedMedia';

const PortfolioGrid = () => {
  const { t } = useLanguage();
  
  return (
    <section className="w-full">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6">
        {portfolioImages.map((item) => (
          <div
            key={item.id}
            className="relative aspect-square overflow-hidden cursor-pointer group"
          >
            {/* Image with grayscale filter that removes on hover */}
            <OptimizedImage
              src={item.image}
              alt={item.titleKey ? t(item.titleKey) : item.title}
              className="w-full h-full object-cover transition-all duration-500"
              style={{ filter: 'grayscale(100%)' }}
              onMouseEnter={(e) => e.target.style.filter = 'grayscale(0%)'}
              onMouseLeave={(e) => e.target.style.filter = 'grayscale(100%)'}
            />
            
            {/* Title overlay - only shows on hover, positioned at bottom */}
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none">
              <h3 className="text-white font-montserrat-bold text-sm md:text-base text-center">
                {item.titleKey ? t(item.titleKey) : item.title}
              </h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PortfolioGrid;
